import React from "react";
import "./styles/index.scss";
import { v4 as uid } from "uuid";

type SwitcherProps = {
  checked?: boolean;
  dataTestId?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const Switcher = ({
  checked = false,
  dataTestId = "",
  onChange,
}: SwitcherProps) => {
  const key = uid();

  return (
    <React.Fragment>
      <div className="activated-block-switcher">
        <input
          data-testid={dataTestId}
          data-checked={checked}
          type="checkbox"
          id={"activated-block-switcher-" + key}
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={"activated-block-switcher-" + key} />
      </div>
    </React.Fragment>
  );
};

export default Switcher;
